import { ActionTypesFactory } from "./ActionTypesFactory";

const messageTemplateActionsTypes = ActionTypesFactory.crudActionTypes(
  "MESSAGE_TEMPLATE"
);

export default messageTemplateActionsTypes;
